import { useCallback, useState } from 'react'
import { usePropertyReader } from '@/hooks/usePropertyReader'
import { clearProps, revertProps } from '@/components/changeRequests'
import valueFallbackComparer from '@/utils/valueComparer'

export function useCoupledProps (targetProp, coupledProps) {
  const [origTarget, ...origCoupled] = usePropertyReader(Array.concat([targetProp], coupledProps), 'originalData')
  const [target] = usePropertyReader([targetProp])

  const clearCoupled = useCallback(clearProps(coupledProps), [])
  const revertCoupled = useCallback(revertProps(
    coupledProps.reduce((obj, val, i) => {
      obj[val] = origCoupled[i]
      return obj
    }, {})),
  [origCoupled])

  const [curTarget, setCurTarget] = useState(target)
  const isChanged = !valueFallbackComparer(origTarget, curTarget)

  const onTargetChange = useCallback((e, newTarget) => {
    if (!valueFallbackComparer(curTarget, newTarget)) {
      setCurTarget(newTarget)
      return valueFallbackComparer(origTarget, newTarget) ? revertCoupled(e) : clearCoupled(e)
    }
  }, [clearCoupled, curTarget, origTarget, revertCoupled])

  return { value: target, onChange: onTargetChange, isChanged }
}



// WEBPACK FOOTER //
// ./src/components/changeRequests/useCoupledProps.js